import type { RouteRecordRaw } from 'vue-router'

import type { AccessLevel } from '@/types/auth.types'

/**
 * Partner-area routes added for the full-app-completion effort (§6
 * bulk Excel import). OWNER: fe-partner (Phase 2).
 *
 * The pre-existing partner routes (`/pms/partners`, `/new`, `/:id`)
 * stay in `pms.routes.ts` (single-author, fe-nav). fe-partner adds new
 * partner-area routes here — never in index.ts or pms.routes.ts.
 *
 * `/pms/partners/import` is static, so vue-router 4's path ranking
 * lets it win over the dynamic `/pms/partners/:id` regardless of
 * registration order. Catch-all stays library-owned in index.ts.
 */
const STAFF: AccessLevel[] = ['access_level.admin', 'access_level.manager']

export const partnerRoutes: RouteRecordRaw[] = [
  {
    path: '/pms/partners/import',
    name: 'pms-partner-bulk-import',
    component: () => import('@/views/pms/partners/PartnerBulkImportView.vue'),
    meta: { access_levels: STAFF },
  },
]
